import React from 'react';
import { PasswordValidationResult } from './validatePassword';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/20/solid';

interface PasswordValidationViewProps {
  validationResult: PasswordValidationResult;
}

const PasswordValidationView: React.FC<PasswordValidationViewProps> = ({ validationResult }) => {
  const rules = [
    { label: 'At least 8 characters', valid: validationResult.length },
    { label: 'At least one lowercase letter', valid: validationResult.lowercase },
    { label: 'At least one uppercase letter', valid: validationResult.uppercase },
    { label: 'At least one number', valid: validationResult.number },
    { label: 'At least one special character', valid: validationResult.specialChar },
  ];

  return (
    <div className="space-y-2">
      {rules.map((rule, index) => (
        <div key={index} className="flex items-center">
          {rule.valid ? (
            <CheckCircleIcon data-testid="valid-icon" className="h-5 w-5 text-green-500" />
          ) : (
            <XCircleIcon data-testid="invalid-icon" className="h-5 w-5 text-gray-300" />
          )}
          <span className="ml-2 text-gray-700">{rule.label}</span>
        </div>
      ))}
    </div>
  );
};

export default PasswordValidationView;
